import { errors } from '../constants/sharedCopy';

const getErrorMessage = (errorType, errorStatus) => {
  const defaultError = errors.default;
  const specificError = errors[errorType];
  if (!specificError) return defaultError;
  return specificError[errorStatus] || specificError.default;
}

export default getErrorMessage;